import { render } from "./PlanillaFormPopup.vue?vue&type=template&id=3ce2e60c&scoped=true"
import script from "./PlanillaFormPopup.vue?vue&type=script&lang=js"
export * from "./PlanillaFormPopup.vue?vue&type=script&lang=js"

import "./PlanillaFormPopup.vue?vue&type=style&index=0&id=3ce2e60c&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\allikamay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ce2e60c"]])

export default __exports__